import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../layout/Navbar";
import { MyContext } from "./context/UserProvider";

export default function CadastroScreen() {
  const navigate = useNavigate();

  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [cpf, setCpf] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");

  const [loading, setLoading] = useState(false);
  const [erroEnvio, setErroEnvio] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [termosUso, setTermosUso] = useState(false);
  const [naoRobo, setNaoRobo] = useState(false);

  const [senhaErro, setSenhaErro] = useState("");
  const [nomeErro, setNomeErro] = useState("");
  const [emailErro, setEmailErro] = useState("");
  const [telefoneErro, setTelefoneErro] = useState("");
  const [cpfErro, setCpfErro] = useState("");

  const [showAviso, setShowAviso] = useState(false);
  const [avisoMessages, setAvisoMessages] = useState([]);

  const {
    setLogin,
    setScrollY,
    showCadastroInProduto,
    setShowCadastroInProduto,
  } = useContext(MyContext);

  useEffect(() => {
    setScrollY(1);
  }, []);

  const isValidCPF = (cpfRaw) => {
    const cpf = cpfRaw.replace(/\D/g, "");
    if (!cpf || cpf.length !== 11) return false;

    if (/^(\d)\1+$/.test(cpf)) return false;

    let soma = 0,
      resto;

    for (let i = 1; i <= 9; i++) soma += parseInt(cpf[i - 1]) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf[9])) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf[i - 1]) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;

    return resto === parseInt(cpf[10]);
  };

  const getUsuarioByLoginRoyal = async (emailParam, senhaParam) => {
    try {
      const apiBase = process.env.REACT_APP_API_URL;

      const response = await fetch(`${apiBase}/api/getUsuarioByLoginRoyal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          emailOrCpf: emailParam || email,
          senha_hash: senhaParam || senha,
        }),
      });

      const dataRaw = await response.json().catch(() => null);

      const userObj = dataRaw && dataRaw.usuario ? dataRaw.usuario : dataRaw;
      let enderecos = dataRaw && dataRaw.enderecos ? dataRaw.enderecos : null;

      if (userObj && userObj.usuario_id != null) {
        if (!enderecos) {
          try {
            const r = await fetch(
              `${apiBase}/api/enderecos?usuario_id=${encodeURIComponent(
                userObj.usuario_id
              )}`,
              {
                method: "GET",
                headers: { "Content-Type": "application/json" },
              }
            );
            if (r.ok) {
              const maybe = await r.json().catch(() => null);
              if (Array.isArray(maybe)) enderecos = maybe;
              else if (maybe && Array.isArray(maybe.enderecos))
                enderecos = maybe.enderecos;
            }
          } catch (err) {
            console.warn(
              "Não foi possível buscar endereços por fallback:",
              err
            );
          }
        }

        const combined = { ...userObj, enderecos: enderecos || [] };
        localStorage.setItem("usuario", JSON.stringify(combined));

        setLogin(true);
        return { ok: true, data: combined };
      }

      return { ok: false, data: dataRaw };
    } catch (err) {
      console.error("Erro ao tentar login automático:", err);
      return { ok: false, error: err.message };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErroEnvio("");
    setSucesso("");
    setSenhaErro("");
    setNomeErro("");
    setCpfErro("");
    setTelefoneErro("");
    setEmailErro("");

    setShowAviso(false);
    setAvisoMessages([]);

    const msgs = [];

    const cpfTrim = (cpf || "").trim();

    if (cpfTrim.length < 1) {
      msgs.push("Preencha o CPF.");
      setCpfErro("Preencha o CPF.");
    } else if (!isValidCPF(cpfTrim)) {
      msgs.push("CPF inválido.");
      setCpfErro("CPF inválido.");
    } else {
      setCpfErro("");
    }

    if (!nome.trim()) {
      msgs.push("Preencha o nome.");
      setNomeErro("Preencha o nome.");
    }

    if (!email.trim()) {
      msgs.push("Preencha o e-mail.");
      setEmailErro("Preencha o e-mail.");
    }

    if (!senha) msgs.push("Preencha a senha.");

    if (!confirmaSenha) msgs.push("Confirme a senha.");

    if (senha && confirmaSenha && senha !== confirmaSenha) {
      setSenhaErro("As senhas não coincidem.");
      msgs.push("As senhas não coincidem.");
    }

    if (!termosUso) msgs.push("É necessário aceitar os termos de uso.");
    if (!naoRobo) msgs.push("Confirme que não é um robô.");

    if (msgs.length > 0) {
      setAvisoMessages(msgs);
      setShowAviso(true);
      return;
    }

    const payload = {
      usuario_nome: nome.trim(),
      usuario_celular: telefone.trim() || null,
      usuario_email: email.trim(),
      usuario_cpf: cpf.replace(/\D/g, "") || null,
      usuario_senha: senha,
    };

    setLoading(true);

    try {
      const apiBase = process.env.REACT_APP_API_URL;

      const res = await fetch(`${apiBase}/api/createAccountRoyal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      let data;
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) data = await res.json();
      else data = await res.text().catch(() => "");

      if (res.status === 201) {
        setSucesso("Cadastro realizado com sucesso!");

        const loginResult = await getUsuarioByLoginRoyal(email, senha);

        setSenha("");
        setConfirmaSenha("");

        if (loginResult.ok) {
          if (showCadastroInProduto) {
            setShowCadastroInProduto(false);
            return;
          }

          navigate("/", { replace: true });
        } else {
          setErroEnvio(
            "Cadastro realizado, mas o login automático falhou. Você pode entrar manualmente."
          );
          console.warn(
            "Login automático falhou:",
            loginResult.data || loginResult.error
          );
        }
      } else if (res.status === 409) {
        const field = data && data.field ? data.field : null;
        const dupMsgs = [];

        if (field === "email")
          dupMsgs.push("Esse email já está em uso. Deseja recuperar a senha?");
        else if (field === "cpf") dupMsgs.push("CPF já está em uso");
        else if (field === "email ou cpf" || !field) {
          dupMsgs.push("Esse email já está em uso. Deseja recuperar a senha?");
          dupMsgs.push("CPF já está em uso");
        } else {
          dupMsgs.push(`Já existe um cadastro com o ${field}.`);
        }

        setAvisoMessages(dupMsgs);
        setShowAviso(true);
        setErroEnvio(`Já existe um cadastro com o ${field || "email ou cpf"}.`);
      } else if (res.status === 400) {
        setErroEnvio(data && data.error ? data.error : "Dados inválidos.");
      } else {
        setErroEnvio(data && data.error ? data.error : `Erro: ${res.status}`);
      }
    } catch (err) {
      console.error("Erro ao chamar API:", err);
      setErroEnvio("Erro ao comunicar com o servidor.");
    } finally {
      setLoading(false);
    }
  };

  const sanitizeSenha = (v) => v.replace(/[',.><\[\]{}\\|!()_+\-=`~:;?^]/g, "");
  const onSenhaChange = (v) => {
    const limpa = sanitizeSenha(v);
    setSenha(limpa);
    if (senhaErro) setSenhaErro("");
  };
  const onConfirmaSenhaChange = (v) => {
    const limpa = sanitizeSenha(v);
    setConfirmaSenha(limpa);
    if (senhaErro) setSenhaErro("");
  };

  return (
    <div
      translate="no"
      style={{
        display: "flex",
        minHeight: "auto",
        backgroundColor: showCadastroInProduto ? "transparent" : "#fff",
        color: "#111827",
        width: "70%",
        maxWidth: "70vh",
        margin: "0 auto",
        padding: "1rem",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        overflow: showCadastroInProduto ? "hidden" : "unset",
      }}
    >
      {!showCadastroInProduto && <Navbar />}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .aviso-overlay {
            position: fixed;
            inset: 0;
            background: ${showCadastroInProduto ? "transparent" : "rgba(0,0,0,0.35)"};
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 60;
          }
          .aviso-box {
            width: 420px;
            background: #fff;
            border-radius: 12px;
            padding: 20px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
            position: relative;
            font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
          }
          .aviso-close {
            position: absolute;
            right: 12px;
            top: 8px;
            cursor: pointer;
            font-weight: 700;
            border: none;
            background: transparent;
            font-size: 18px;
          }
          .aviso-bullets {
            margin: 12px 0 18px 0;
            padding-left: 18px;
          }
          .aviso-button {
            display: block;
            margin: 0 auto;
            padding: 10px 26px;
            border-radius: 10px;
            border: 2px solid #111;
            background: #fff;
            cursor: pointer;
            font-size: 1rem;
          }
        `}
      </style>

      <form
        onSubmit={handleSubmit}
        style={{
          boxShadow: showCadastroInProduto
            ? "none"
            : "0px 25px 15px 15px rgba(0, 0, 0, 0.3)",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: showCadastroInProduto ? "#fff" : "transparent",
          marginTop: showCadastroInProduto ? "0px" : "100px",
          borderRadius: 5,
          padding: 20,
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontWeight: 700,
            color: "#000",
            marginTop: 0,
          }}
        >
          Cadastre-se
        </h2>

        <div>
          <label htmlFor="nome" style={labelStyle}>
            Nome completo
          </label>
          <input
            id="nome"
            type="text"
            placeholder="Digite seu nome completo"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            style={inputStyle}
          />
          {nomeErro && (
            <div
              style={{
                color: "red",
                fontSize: "0.9rem",
                marginBottom: "0.5rem",
              }}
            >
              {nomeErro}
            </div>
          )}
        </div>

        <div>
          <label htmlFor="email" style={labelStyle}>
            E-mail
          </label>
          <input
            id="email"
            type="email"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
          {emailErro && (
            <div
              style={{
                color: "red",
                fontSize: "0.9rem",
                marginBottom: "0.5rem",
              }}
            >
              {emailErro}
            </div>
          )}
        </div>

        <div>
          <label htmlFor="telefone" style={labelStyle}>
            Celular
          </label>
          <input
            id="telefone"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="(00) 00000-0000"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value.replace(/\D/g, ""))}
            style={inputStyle}
          />
          {telefoneErro && (
            <div
              style={{
                color: "red",
                fontSize: "0.9rem",
                marginBottom: "0.5rem",
              }}
            >
              {telefoneErro}
            </div>
          )}
        </div>

        <div>
          <label htmlFor="cpf" style={labelStyle}>
            CPF
          </label>
          <input
            id="cpf"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="00000000000"
            value={cpf}
            onChange={(e) => setCpf(e.target.value.replace(/\D/g, ""))}
            style={inputStyle}
          />
          {cpfErro && (
            <div
              style={{
                color: "red",
                fontSize: "0.9rem",
                marginBottom: "0.5rem",
              }}
            >
              {cpfErro}
            </div>
          )}
        </div>

        <div>
          <label htmlFor="senha" style={labelStyle}>
            Senha
          </label>
          <input
            id="senha"
            type="password"
            placeholder=""
            value={senha}
            onChange={(e) => onSenhaChange(e.target.value)}
            style={inputStyle}
          />
          {senhaErro && (
            <div
              style={{
                color: "red",
                fontSize: "0.9rem",
                marginBottom: "0.5rem",
              }}
            >
              {senhaErro}
            </div>
          )}
        </div>

        <div>
          <label htmlFor="confirmaSenha" style={labelStyle}>
            Confirme a senha
          </label>
          <input
            id="confirmaSenha"
            type="password"
            placeholder=""
            value={confirmaSenha}
            onChange={(e) => onConfirmaSenhaChange(e.target.value)}
            style={inputStyle}
          />
          {senhaErro && (
            <div
              style={{
                color: "red",
                fontSize: "0.9rem",
                marginBottom: "0.5rem",
              }}
            >
              {senhaErro}
            </div>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <input
            type="checkbox"
            id="naoRobo"
            checked={naoRobo}
            onChange={(e) => setNaoRobo(e.target.checked)}
          />
          <label
            htmlFor="naoRobo"
            style={{ fontSize: "0.875rem", color: "#374151" }}
          >
            Não sou um robô
          </label>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <input
            type="checkbox"
            id="termosUso"
            checked={termosUso}
            onChange={(e) => setTermosUso(e.target.checked)}
          />
          <label
            htmlFor="termosUso"
            style={{ fontSize: "0.875rem", color: "#374151" }}
          >
            Aceito os termos de uso
          </label>
        </div>

        {erroEnvio && (
          <div style={{ color: "red", fontSize: "0.9rem" }}>{erroEnvio}</div>
        )}
        {sucesso && (
          <div style={{ color: "green", fontSize: "0.9rem" }}>{sucesso}</div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            backgroundColor: "#facc15",
            color: "#000",
            fontWeight: 500,
            padding: "0.75rem",
            borderRadius: "0.375rem",
            border: "none",
            marginTop: "1rem",
            cursor: loading ? "default" : "pointer",
          }}
        >
          {loading ? "Enviando..." : "Concluir Cadastro"}
        </button>
      </form>

      {showAviso && (
        <div className="aviso-overlay" role="dialog" aria-modal="true">
          <div className="aviso-box">
            <button
              className="aviso-close"
              aria-label="Fechar"
              onClick={() => setShowAviso(false)}
            >
              ✕
            </button>
            <div
              style={{
                fontSize: "0.95rem",
                color: "#111827",
                marginBottom: "8px",
              }}
            >
              <strong>Atenção</strong>
            </div>
            <ul className="aviso-bullets">
              {avisoMessages.map((m, i) => (
                <li key={i} style={{ marginBottom: "8px", color: "#111827" }}>
                  {m}
                </li>
              ))}
            </ul>
            <button
              className="aviso-button"
              onClick={() => setShowAviso(false)}
            >
              Entendi
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const labelStyle = {
  display: "block",
  fontSize: "0.875rem",
  color: "#374151",
  marginBottom: "0.25rem",
  margin: 5,
};

const inputStyle = {
  width: "90%",
  padding: "0.75rem",
  backgroundColor: "#f9fafb",
  border: "1px solid #d1d5db",
  borderRadius: "0.375rem",
  color: "#111827",
  fontSize: "1rem",
};